import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import { FIELD_DATA, FETCHED_OBJECT_PROPERTY, ENROLLMENT_EVENT_PROPERTY, ENROLLMENT_DATASET_COLUMN } from 'automation-ui-formula-editor/formula-editor/data-passing/constants/DataSourceOptions';
import StaticBranchActionDetailFromDataToken from 'automation-ui-action-features/actions/static-branch/StaticBranchActionDetailFromDataToken';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticBranchActionSummary({
  actionId,
  actionMetadata,
  flowObjectTypeId,
  getHeaderTitle,
  getActionOutputsForTargetActionById
}) {
  const inputType = actionMetadata.getInputType();
  if (inputType === FETCHED_OBJECT_PROPERTY || inputType === ENROLLMENT_EVENT_PROPERTY || inputType === ENROLLMENT_DATASET_COLUMN) {
    const token = actionMetadata.getInputValue().getPropertyToken();
    return /*#__PURE__*/_jsx(StaticBranchActionDetailFromDataToken, {
      langKey: "automation-ui-action-features.action-features.static-branch.summary.fetched-object",
      token: token
    });
  } else if (inputType === FIELD_DATA) {
    var _actionOutput$typeDef;
    const sourceActionId = actionMetadata.getValueIdentifierActionId();
    const sourceOutputName = actionMetadata.getValueIdentifierDataKey();
    const actionOutputs = getActionOutputsForTargetActionById(actionId);
    const {
      outputFieldDefinitions: sourceActionOutputs
    } = actionOutputs.find(({
      actionId: outputActionId
    }) => outputActionId === sourceActionId) || {
      outputFieldDefinitions: []
    };
    const actionOutput = sourceActionOutputs.find(({
      typeDefinition: {
        name
      }
    }) => name === sourceOutputName);
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.static-branch.summary.data-passing",
      options: {
        sourceActionName: sourceActionId && /*#__PURE__*/_jsx("strong", {
          children: getHeaderTitle({
            actionId: sourceActionId
          })
        }),
        sourcePropertyName: /*#__PURE__*/_jsx("strong", {
          children: actionOutput && ((_actionOutput$typeDef = actionOutput.typeDefinition.label) !== null && _actionOutput$typeDef !== void 0 ? _actionOutput$typeDef : actionOutput.typeDefinition.name)
        })
      }
    });
  } else {
    const propertyName = actionMetadata.getInputValue().getPropertyName();
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.static-branch.summary.enrolled-object",
      options: {
        sourcePropertyName: /*#__PURE__*/_jsx(PropertyName, {
          propertyName: propertyName,
          objectTypeId: flowObjectTypeId
        })
      }
    });
  }
}